import EventEmitter from "base/EventEmitter";

class CanvasImage extends EventEmitter {

    constructor($img, masks, overlay = null) {
        super();

        this.overlay = overlay;

        if ($img.length === 0) return;
        $img.data("canvas", this);

        this.$img = $img;
        this.canvas = eotwJSXFactory('canvas', {class: $img.attr("class"), style: "pointer-events:none;"})[0];
        this.$img.after(this.canvas);


        this.context = this.canvas.getContext('2d');
        this.context.globalCompositeOperation = 'default';

        this.offScreenCanvas = eotwJSXFactory('canvas')[0];
        this.offscreenContext = this.offScreenCanvas.getContext('2d');

        this.masks = masks;

        this.loaded = false;

        CanvasImage.add_item(this);
        this.update();

        $(window).on("resize", () => this.update());
    }

    getImage() {
        let imgSrc = this.$img[0].currentSrc || this.$img[0].src;
        return CanvasImage.load_image(imgSrc);

    }

    static load_image(url) {
        if ('undefined' !== typeof CanvasImage.loaded_images[url]) {
            return CanvasImage.loaded_images[url];
        }

        return CanvasImage.loaded_images[url] = new Promise((resolve, reject) => {
            let img = document.createElement('img');
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);

            img.src = url + '?v=' + window.CONFIG.buildNumber;
        });
    }

    getMasks() {
        let promises = this.masks[this.closestLowerMatch(this.masks, window.innerWidth)].map((mask) => CanvasImage.load_image(mask.url).then((img) => {
            return {img, mask};
        }));


        return Promise.all(promises);
    }

    update() {
        this.canvas.width = this.canvas.clientWidth;
        this.canvas.height = this.canvas.clientHeight;


        Promise.all([this.getImage(), this.getMasks()]).then(([image, masks]) => {
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

            let maskUrls = [];
            this.context.globalCompositeOperation = 'source-over';
            masks.forEach(({img, mask}) => {
                maskUrls.push(mask.url);
                this.drawMask(img, mask);
            });
            this.$img.attr("data-masks", maskUrls.join(", "))

            this.context.globalCompositeOperation = 'xor';
            this.drawImageProp(image, 0, 0, this.canvas.width, this.canvas.height, 0.5, 0.5);

            if (!this.loaded) {
                this.$img.css({opacity: 0});
                this.loaded = true;
                this.emit("load");
            }
        }).catch((e) => {
            if (!this.loaded) {
                this.loaded = true;
                this.emit("error");
            }
        })

    }

    closestLowerMatch(obj, test) {

        let prev = -1;
        let i;
        for (i in obj) {
            const n = parseInt(i);
            if ((prev != -1) && (test < n))
                return prev;
            else
                prev = n;
        }
        return prev;
    }

    drawMask(img, mask) {

        let top = 0;
        let left = 0;
        let width = img.width;
        let height = img.height;

        if (this.canvas.width > img.width) {
            width = this.canvas.width;
            height = (img.height / img.width) * this.canvas.width;
        }

        if (mask.vPos == 'bottom') {
            top = this.canvas.height - height;
        } else if (mask.vPos == 'center') {
            top = (this.canvas.height / 2) - (height / 2);
        }

        if (mask.hPos == 'center' && this.canvas.width < img.width) {
            left = (this.canvas.width / 2) - (img.width / 2);
        }

        this.context.drawImage(img, left, top, width, height);
    }

    drawImageProp(img, x, y, w, h, offsetX, offsetY) {

        if (arguments.length === 2) {
            x = y = 0;
            w = this.context.canvas.width;
            h = this.context.canvas.height;
        }

        // default offset is center
        offsetX = typeof offsetX === "number" ? offsetX : 0.5;
        offsetY = typeof offsetY === "number" ? offsetY : 0.5;

        // keep bounds [0.0, 1.0]
        if (offsetX < 0) offsetX = 0;
        if (offsetY < 0) offsetY = 0;
        if (offsetX > 1) offsetX = 1;
        if (offsetY > 1) offsetY = 1;

        const iw = img.width,
            ih = img.height,
            r = Math.min(w / iw, h / ih);
        let nw = iw * r,   // new prop. width
            nh = ih * r,   // new prop. height
            cx, cy, cw, ch, ar = 1;

        // decide which gap to fill
        if (nw < w) ar = w / nw;
        if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
        nw *= ar;
        nh *= ar;

        // calc source rectangle
        cw = iw / (nw / w);
        ch = ih / (nh / h);

        cx = (iw - cw) * offsetX;
        cy = (ih - ch) * offsetY;

        // make sure source rectangle is valid
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cw > iw) cw = iw;
        if (ch > ih) ch = ih;

        // fill image in dest. rectangle
        this.context.drawImage(this.addOverlay(img), cx, cy, cw, ch, x, y, w, h);
    }

    static add_item(canvasImage) {
        CanvasImage.items.push(canvasImage);

        canvasImage.on("load error", CanvasImage.check_all_loaded);
    }

    static check_all_loaded() {
        let loaded = true;

        CanvasImage.items.forEach((item) => {
            if (!item.loaded) loaded = false;
        });

        if (loaded) {
            $("body").removeClass("loading");
        }
    }

    addOverlay(image) {
        if (!this.overlay) return image;

        this.offScreenCanvas.width = image.width;
        this.offScreenCanvas.height = image.height;

        this.offscreenContext.clearRect(0, 0, this.offScreenCanvas.width, this.offScreenCanvas.height);

        this.offscreenContext.drawImage(image, 0, 0, this.offScreenCanvas.width, this.offScreenCanvas.height);
        this.offscreenContext.fillStyle = this.overlay;

        this.offscreenContext.fillRect(0, 0, this.offScreenCanvas.width, this.offScreenCanvas.height);

        return this.offScreenCanvas;
    }
}

CanvasImage.loaded_images = {};
CanvasImage.items = [];

export default CanvasImage;
